/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Save_Time_TitleInputs */

const en_homepage_save_time_title = /** @type {(inputs: Homepage_Save_Time_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save time by choosing which sections to listen to`)
};

const es_homepage_save_time_title = /** @type {(inputs: Homepage_Save_Time_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra tiempo eligiendo qué secciones escuchar`)
};

/**
* | output |
* | --- |
* | "Save time by choosing which sections to listen to" |
*
* @param {Homepage_Save_Time_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_save_time_title = /** @type {((inputs?: Homepage_Save_Time_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Save_Time_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_save_time_title(inputs)
	return en_homepage_save_time_title(inputs)
});